import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { HelpFilesVm } from 'app/shared/generated/HelpFiles/Models/HelpFilesVm';

@Component({
    selector: 'pcg-help-videos',
    templateUrl: './help-videos.component.html',
    styleUrls: ['./help-videos.component.scss'],
    standalone: false
})
export class HelpVideosComponent implements OnInit {

	id: number;
	name: string;
	description: string;
	moduleName: string;
	url: string;

	constructor(
		private activeRoute: ActivatedRoute
		, private httpClient: HttpClient
	) { }

	ngOnInit() {
		this.id = parseInt(this.activeRoute.snapshot.paramMap.get('id'), 10);
		this.getVideoContent();
	}

	getVideoContent() {
		this.httpClient.get(`api/HelpFiles/HelpFiles/GetDetails/${this.id}`)
			.subscribe((model: HelpFilesVm) => {
				const videoId = Number(model.videoId);
				this.url = `https://player.vimeo.com/video/${videoId}`;
				this.name = model.name;
				this.description = model.description;
				this.moduleName = model.moduleName;
			}
		);
	}
}
